const autoNgTemplateLoaderTemplate1 = require('./revenue-report.template.html');

'use strict';

(function () {
    angular
        .module('app.revenueReport', [])
        .config(revenueReportConfig);

    revenueReportConfig.$inject = ['$routeProvider'];

    function revenueReportConfig($routeProvider) {
        $routeProvider
            .when('/revenue-report', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'RevenueReportController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                }
            })
    }
})();
